// extracted by mini-css-extract-plugin
var _1 = "discount-syOsa";
var _2 = "discounts-ARiAz";
var _3 = "error-MyL8v";
var _4 = "group-KzZuy";
var _5 = "image-Q7eOt";
var _6 = "img-Lrk1s";
var _7 = "name-nAJMn";
var _8 = "price-ytaJI";
var _9 = "prices-wfy26";
var _a = "product-aq0RX";
var _b = "remove-YqLdw";
var _c = "scroll-pvUhu";
var _d = "status-WfTka";
var _e = "throw-gcPDw";
var _f = "wrap-g3yOk";
var _10 = "wrapper-cWZ00";
export { _1 as "discount", _2 as "discounts", _3 as "error", _4 as "group", _5 as "image", _6 as "img", _7 as "name", _8 as "price", _9 as "prices", _a as "product", _b as "remove", _c as "scroll", _d as "status", _e as "throw", _f as "wrap", _10 as "wrapper" }
